module.exports = __webpack_public_path__ + "media/application/images/svgs/square-11cce2a1a3fc9e4d909bda06f8f73eef.svg";